// #174 — SCHEDULE_REMINDER arrow-menu presets.
//
// Each preset's `resolve()` is called at click time so the relative dates
// (Tomorrow, Next Monday, ...) are always computed against "now" — not
// captured at render. Pulled into its own module so we can unit-test the
// resolver without rendering ChecklistItemRow.

export const SCHEDULE_REMINDER_PRESETS = [
    {
        id: 'tomorrow-9',
        label: 'Tomorrow at 9am',
        resolve: () => {
            const d = new Date();
            d.setDate(d.getDate() + 1);
            d.setHours(9, 0, 0, 0);
            return d;
        },
    },
    {
        id: 'in-3-days',
        label: 'In 3 days',
        resolve: () => {
            const d = new Date();
            d.setDate(d.getDate() + 3);
            d.setHours(9, 0, 0, 0);
            return d;
        },
    },
    {
        id: 'next-monday',
        label: 'Next Monday at 9am',
        resolve: () => {
            const d = new Date();
            const day = d.getDay(); // 0=Sun, 1=Mon
            const delta = ((1 - day + 7) % 7) || 7;
            d.setDate(d.getDate() + delta);
            d.setHours(9, 0, 0, 0);
            return d;
        },
    },
    {
        id: 'next-week',
        label: 'Next week at 9am',
        resolve: () => {
            const d = new Date();
            d.setDate(d.getDate() + 7);
            d.setHours(9, 0, 0, 0);
            return d;
        },
    },
];
